import ProfileLeftPanel from '../../components/profile-left-panel/ProfileLeftPanel';
import ProfileMidPanel from '../../components/profile-mid-panel/ProfileMidPanel';
import ProfileSuggestions from '../../components/profile-suggestions/ProfileSuggestions';
import { useProfileContext } from './profile-context';
import styles from './Profile.module.scss';

const Profile = () => {
  const { userType } = useProfileContext();

  return (
    <main className={styles.profile}>
      <section className={styles.profileLeftPanel}>
        <ProfileLeftPanel />
      </section>
      <section className={styles.profileMidPanel}>
        <ProfileMidPanel />
      </section>
      <section className={styles.suggestions}>
        <ProfileSuggestions />
      </section>
    </main>
  );
};

export default Profile;
